export const EMAIL_SUPPORT = 'support@ads.wp.pl'
